import React, { memo } from 'react';

import SeoTextsBlocks from 'components/SeoTextsBlocks';
// import Footer from 'components/Footer';
import BreadCrumbs from 'components/NbuPageBreadCrumbs';
import Banner from 'components/Banner';

import { BreadCrumbsWrapper } from 'components/FooterStyles';

import { Wrapper } from './styles';

const NbuPageFooter = memo(() => (
  <Wrapper>
    <SeoTextsBlocks />

    {/* <Footer /> */}

    <BreadCrumbsWrapper>
      <Banner id="rp-react-banner-bottom" slot="bn-slot-bottom" />
      <BreadCrumbs />
      <Banner id="rp-react-banner-catfish" slot="bn-slot-catfish" />
    </BreadCrumbsWrapper>
  </Wrapper>
));

export default NbuPageFooter;
